import { createFileRoute } from "@tanstack/react-router";

import { OrganizationsPanel } from "../../../workspaces/settings/OrganizationsPanel";

export const Route = createFileRoute("/_console/settings/organizations/")({
  component: OrganizationsPanel,
});
